import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z"/>
  <path d="M20 16a8 8 0 1 0-16 0"/>
  <path d="M12 4v4"/>
  <path d="M10 4h4"/>
</svg>`;

const Concierge = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='concierge' svg={svg} {...props} />
  )
);

Concierge.displayName = 'ConciergeIcon';

export default Concierge;
